// extracted by mini-css-extract-plugin
export default {"ButtonHoverExpand":"ButtonHoverExpand_ButtonHoverExpand__PyJjX"};